import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveUpdateRegistro({ commit }, data) {
      try {
        return await api.post(
          `/centros-custos/${data.codCCustoPai}/filhos/orcamento/${data.orcamentoId}/${data.codCCustoFilho}/registros`,
          data.registro,
        )
      } catch (error) {
        throw error
      }
    },

    async getRegistros({ commit }, filters) {
      try {
        const response = await api.get(
          `/centros-custos/${filters.codCCustoPai}/filhos/orcamento/${filters.orcamentoId}/${filters.codCCustoFilho}/registros?periodoOrcamento=${filters.periodoOrcamento}&exibirNaturezasInativas=${filters.exibirNaturezasInativas}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
